/* eslint-disable class-methods-use-this */
/* global axios */
import JwtAuth from './jwtAuth';

const url =
  process.env.FRONTEND_ENV === 'develop'
    ? 'https://staging.chatlyn.com/payments/api'
    : window.location.protocol +
      '//' +
      window.location.hostname +
      '/payments/api';

const DEFAULT_PARAMS = {
  page: 1,
  limit: 10,
  // status: PAYMENT_STATUS.OPEN
};

class PaymentsAPI {
  // Uses a numeric chatlyn account ID
  async getPaymentsAccountWithChatlynAccountId(accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.get(`${url}/accounts/chatlyn/${accountId}`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  }

  // Uses an UUID
  async getPaymentsAccount(id) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.get(`${url}/accounts/${id}`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  }

  async getPaymentStatus(accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.get(`${url}/payment-status/account/${accountId}`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
    });
  }

  async getInvoicesByChatlynAccountId(chatlynAccountId, params = DEFAULT_PARAMS) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();

    return axios.get(`${url}/invoices/admin/account/${chatlynAccountId}`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
      params,
    });
  }
}

export default new PaymentsAPI();
